/** Namespace `products` — bản gốc tiếng Việt. Khoá phẳng, tên camelCase; `{biến}` để chèn. */
export const products = {
  title: "Danh mục sản phẩm",
  subtitle: "Sản phẩm → dịch vụ → tài nguyên. Danh mục khai trong mã nguồn và nạp bằng ",
  loadListFailed: "Không đọc được danh mục sản phẩm.",
  emptyBefore: "Danh mục chưa được nạp. Chạy ",
  emptyAfter: ".",
  cardMeta: "{services} dịch vụ · {resources} tài nguyên · {criticality}",
  noOwner: "Chưa có chủ",

  loadFailed: "Không đọc được sản phẩm.",
  noOwnerAssign: "Chưa có chủ — gán ngay",
  services: "Dịch vụ",
  "col.service": "Dịch vụ",
  "col.type": "Loại",
  "col.tier": "Mức",
  "col.liveness": "Sống",
  "col.resourcesUsed": "Dùng tài nguyên",
  "col.dependsOn": "Phụ thuộc",
  noOwnerTag: "chưa có chủ",
  up: "Sống",
  down: "Không trả lời",
  resources: "Tài nguyên",
  "col.resource": "Tài nguyên",
  "col.observability": "Hub quan sát",
  "col.size": "Dung lượng",
  userMetricsBefore: "Chỉ số người dùng của sản phẩm ",
  userMetricsStrong: "chưa đo được",
  userMetricsMiddle: ": ",
  userMetricsAfter:
    " lưu theo connector, và quy chúng lên sản phẩm lại vấp đúng bài toán « cộng phép đếm-phân-biệt » đã từ chối ở màn Người dùng. Số theo từng nguồn có ở ",
  userMetricsLink: "Người dùng",
  userMetricsEnd: ".",
} as const;
